<template>
  <div class="text-start">
    <h1>Imprint</h1>
    <strong>Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</strong><br />

    <span>Jan Oliver Kolb</span><br />
    <span>Igelhecke 17</span><br />
    <span>89518 Heidenheim an der Brenz</span><br /><br />

    <strong>Kontakt</strong><br />
    <span>E-Mail: janoliverkolb@hotmail.de</span><br /><br />

    <strong>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</strong><br />
    <span>Jan Oliver Kolb (Anschrift wie oben)</span><br /><br />

    <strong>Hinweis</strong><br />
    <span
      >Dieses Angebot wird privat und nicht-kommerziell betrieben und richtet
      sich an einen begrenzten Nutzerkreis aus Familie und Freunden.</span
    >
  </div>
</template>
